export function deepClone<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}

export function setAtPath(
  root: Record<string, unknown>,
  path: string[],
  newValue: unknown,
): Record<string, unknown> {
  if (path.length === 0) {
    return root;
  }
  const [head, ...rest] = path;
  if (rest.length === 0) {
    return { ...root, [head]: newValue };
  }
  const current = root[head];
  const child =
    current && typeof current === 'object' && !Array.isArray(current)
      ? (current as Record<string, unknown>)
      : ({} as Record<string, unknown>);
  return { ...root, [head]: setAtPath(child, rest, newValue) };
}
